import { formatDate } from "common/functions";

import { FaRegClock } from "components/atoms/Icon/fa/FaRegClock";
import { FiCalendar } from "components/atoms/Icon/fi/FiCalendar";
import { FiUser } from "components/atoms/Icon/fi/FiUser";
const htmlparser = require("htmlparser2");

export default function AuthorAndTime({
  timeRead,
  fullHead,
  hide,
  urlContentTeam,
  authorName,
}) {
  let publishedTime = Date.now();
  let modifiedTime = Date.now();

  if (fullHead) {
    const script = fullHead.match(/<script.*?<\/script>/g);

    const parser = new htmlparser.Parser({
      ontext: (text) => {
        const data = JSON.parse(text)["@graph"].find(
          (item) => item["@type"] === "Article"
        );

        if (data?.datePublished) {
          publishedTime = data.datePublished;
        }

        if (data?.dateModified) {
          modifiedTime = data.dateModified;
        }
      },
    });

    parser.write(script);
    parser.end();
  }

  return (
    <>
      {!(hide === 1) && (
        <div className={" mr-6  inline-flex items-center"}>
          <FiUser size={24} className="mr-2 p-0.5" />

          <i className="font-medium">
            <a
              href={
                urlContentTeam && urlContentTeam.trim().length > 0
                  ? urlContentTeam
                  : "/author/bbcincorp-content-team"
              }
            >
              {authorName && authorName.trim().length > 0
                ? authorName
                : "Content Team"}
            </a>
          </i>
        </div>
      )}
      {!(hide === 2) && (
        <div className={"mr-6 hidden items-center lg:inline-flex"}>
          <FaRegClock size={24} className="mr-2 p-0.5" />{" "}
          <i className="font-medium">
            {timeRead ? timeRead : "6 minutes"} read
          </i>
        </div>
      )}
      {!(hide === 3) && (
        <div className={"inline-flex items-center lg:mr-6"}>
          <FiCalendar size={24} className="mr-2 p-0.5" />
          <i className="font-medium">{formatDate(publishedTime)}</i>
        </div>
      )}
      <div className="mt-2 items-center text-center font-medium lg:mt-0 lg:flex lg:text-left">
        Last Updated on {formatDate(modifiedTime)}
      </div>
    </>
  );
}
